import styled from 'styled-components';

export const StepOne = styled.div`

  padding: 2rem;
  padding-top: 5rem;

  p {
    font-size: 2rem;
    margin-bottom: 1.5rem;

    svg {
      display: inline-block;
      height: 12px;
      margin: 0 6px;
      transform: translateY(2px);
      color: white;
      font-size: 17px;
      background-color: rgb(0,0,0);
      color: white;
      padding: 2px;
      border-radius: 2px;
    }
  }
`